import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetOrganizationsByWorkspaceIdQueryVariables = Types.Exact<{
  workspace_id: Types.Scalars['uuid']['input'];
  org_types?: Types.InputMaybe<Array<Types.Scalars['String']['input']> | Types.Scalars['String']['input']>;
}>;


export type GetOrganizationsByWorkspaceIdQuery = { __typename?: 'query_root', organizations: Array<{ __typename?: 'organizations', id: any, name: string, contact_name?: string | null, email?: string | null, type?: string | null, organizationImageURL?: string | null, workspace_id: any, created_at?: any | null, updated_at?: any | null, org_properties: Array<{ __typename?: 'properties', id: any, name: string, address?: string | null, address_id?: any | null, premium?: boolean | null, tier_status?: string | null, standardized_address?: { __typename?: 'addresses', id: any, street_1: string, street_2?: string | null, city: string, state: string, postal_code: string, country: string } | null, property_users: Array<{ __typename?: 'user_properties', user?: { __typename?: 'users', id: string, first_name: string, last_name: string, email: string, role?: string | null, profile_photo?: string | null } | null }> }> }> };


export const GetOrganizationsByWorkspaceIdDocument = gql`
    query getOrganizationsByWorkspaceId($workspace_id: uuid!, $org_types: [String!]) {
  organizations(
    where: {_and: [{workspace_id: {_eq: $workspace_id}}, {type: {_in: $org_types}}]}
    order_by: {name: asc}
  ) {
    id
    name
    contact_name
    email
    type
    organizationImageURL
    workspace_id
    created_at
    updated_at
    org_properties(where: {deleted_at: {_is_null: true}}) {
      id
      name
      address
      address_id
      standardized_address {
        id
        street_1
        street_2
        city
        state
        postal_code
        country
      }
      premium
      tier_status
      property_users {
        user {
          id
          first_name
          last_name
          email
          role
          profile_photo
        }
      }
    }
  }
}
    `;

/**
 * __useGetOrganizationsByWorkspaceIdQuery__
 *
 * To run a query within a React component, call `useGetOrganizationsByWorkspaceIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationsByWorkspaceIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationsByWorkspaceIdQuery({
 *   variables: {
 *      workspace_id: // value for 'workspace_id'
 *      org_types: // value for 'org_types'
 *   },
 * });
 */
export function useGetOrganizationsByWorkspaceIdQuery(baseOptions: Apollo.QueryHookOptions<GetOrganizationsByWorkspaceIdQuery, GetOrganizationsByWorkspaceIdQueryVariables> & ({ variables: GetOrganizationsByWorkspaceIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationsByWorkspaceIdQuery, GetOrganizationsByWorkspaceIdQueryVariables>(GetOrganizationsByWorkspaceIdDocument, options);
      }
export function useGetOrganizationsByWorkspaceIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationsByWorkspaceIdQuery, GetOrganizationsByWorkspaceIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationsByWorkspaceIdQuery, GetOrganizationsByWorkspaceIdQueryVariables>(GetOrganizationsByWorkspaceIdDocument, options);
        }
export function useGetOrganizationsByWorkspaceIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrganizationsByWorkspaceIdQuery, GetOrganizationsByWorkspaceIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOrganizationsByWorkspaceIdQuery, GetOrganizationsByWorkspaceIdQueryVariables>(GetOrganizationsByWorkspaceIdDocument, options);
        }
export type GetOrganizationsByWorkspaceIdQueryHookResult = ReturnType<typeof useGetOrganizationsByWorkspaceIdQuery>;
export type GetOrganizationsByWorkspaceIdLazyQueryHookResult = ReturnType<typeof useGetOrganizationsByWorkspaceIdLazyQuery>;
export type GetOrganizationsByWorkspaceIdSuspenseQueryHookResult = ReturnType<typeof useGetOrganizationsByWorkspaceIdSuspenseQuery>;
export type GetOrganizationsByWorkspaceIdQueryResult = Apollo.QueryResult<GetOrganizationsByWorkspaceIdQuery, GetOrganizationsByWorkspaceIdQueryVariables>;